import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		user: {},
		token: '',
        loading : false
	},
	getters:{
		getUser: state => {
			return state.user
		},
		getToken: state => {
			return state.token
		},
		getLoading: state => {
			return state.loading
		},


	},
	mutations: {
		setUser (state,user) {
			state.user = user;
		},
        delUser(state){
            state.user = {};
        },
		setToken (state,token) {
			state.token = token;
		},
		setLoading (state,loading) {
			state.loading = loading;
            console.log('setLoading', loading)
		}
	}
})
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js